import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { AuthContext } from '../../context/AuthContext';
import { AlunoContext } from '../../context/AlunoContext';
import { ContaReceberContext } from '../../context/ContaReceberContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { ContaReceberType, CreateContaReceberType, UpdateContaReceberType, EfetuarBaixaReceberRequest } from '../../context/hooks/useContaReceber';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateContaReceberModal } from '../../components/ContaReceber/CreateContaReceberModal';
import { EditContaReceberModal } from '../../components/ContaReceber/EditContaReceberModal';
import { DetalhesContaReceberModal } from '../../components/ContaReceber/DetalhesContaReceberModal';
import { BoletoParcelasModal } from '../../components/ContaReceber/BoletoParcelasModal';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';
import { ActionsMenu, ActionsMenuItem } from '../../components/ActionsMenu/ActionsMenu';

const ContaReceber = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listContaReceber, getAllContaReceberPaged, createContaReceber, updateContaReceber, deleteContaReceber, efetuarBaixaContaReceber, efetuarBaixaLoteContaReceber, baixarBoletos, contaReceberTotalValor, sincronizarRestricoes } = useContext(ContaReceberContext);
    const [syncingRestricoes, setSyncingRestricoes] = useState(false);
    const [selecionadas, setSelecionadas] = useState<Set<number>>(new Set());
    const [expandedVendas, setExpandedVendas] = useState<Set<number>>(new Set());
    const { handleGetContaFinanceiraByEmpresaId, listContaFinanceiraByEmpresa } = useContext(ContaFinanceiraContext);
    const { handleGetCategoriaFinanceiraByEmpresaId, listCategoriaFinanceiraByEmpresa } = useContext(CategoriaFinanceiraContext);
    const { handleGetFormaPagamentoByEmpresaId, listFormaPagamentoByEmpresa } = useContext(FormaPagamentoContext);
    const { getAlunoPaged } = useContext(AlunoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [editingContaReceber, setEditingContaReceber] = useState<UpdateContaReceberType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [detalhesContaId, setDetalhesContaId] = useState<number | null>(null);
    const [boletoModalGrupo, setBoletoModalGrupo] = useState<{ vendaId: number; parcelas: ContaReceberType[] } | null>(null);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [groupPage, setGroupPage] = useState(1);

    // Paginação real acontece aqui no cliente, sobre as linhas JÁ AGRUPADAS por
    // venda — não teria como paginar certo no servidor sobre linhas cruas, porque
    // uma venda de 20 parcelas pode ocupar várias "páginas" cruas e virar 1 linha
    // resumo em cada uma (ex.: página 2 mostrando só 1 registro). Por isso sempre
    // buscamos um lote grande do backend (RAW_FETCH_SIZE) de uma vez.
    const RAW_FETCH_SIZE = 500;

    const [filters, setFilters] = useState({
        dataInicial: '',
        dataFinal: '',
        status: '',
        codigoTransacao: '',
        documento: '',
        historico: '',
        contaFinanceiraId: '',
        categoriaFinanceiraId: '',
        formaPagamentoId: '',
        alunoId: '',
        restricao: ''
    });
    const [selectedAlunoOption, setSelectedAlunoOption] = useState<{ value: number; label: string } | null>(null);

    useEffect(() => {
        setLoading(true);

        handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);

        getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar contas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    // Troca de página é só um recorte client-side dos grupos já carregados —
    // não busca nada novo do backend (ver RAW_FETCH_SIZE acima).
    const onChangePaginationCommon = (e: any, value: any) => {
        setGroupPage(value);
    };


    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        setGroupPage(1);
        getAllContaReceberPaged(
            1,
            RAW_FETCH_SIZE,
            objUserTk.EmpresaId,
            filters.dataInicial,
            filters.dataFinal,
            filters.status !== '' ? Number(filters.status) : undefined,
            filters.codigoTransacao ? Number(filters.codigoTransacao) : undefined,
            filters.documento || undefined,
            filters.historico || undefined,
            filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
            filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
            filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
            filters.alunoId ? Number(filters.alunoId) : undefined
        )
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({
            dataInicial: '',
            dataFinal: '',
            status: '',
            codigoTransacao: '',
            documento: '',
            historico: '',
            contaFinanceiraId: '',
            categoriaFinanceiraId: '',
            formaPagamentoId: '',
            alunoId: '',
            restricao: ''
        });
        setSelectedAlunoOption(null);
        setLoading(true);
        setGroupPage(1);
        getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditContaReceber = (contaReceber: ContaReceberType) => {
        setEditingContaReceber(contaReceber);
        setEditModalOpen(true);
    };

    const [confirmDeleteContaReceberId, setConfirmDeleteContaReceberId] = useState<number | null>(null);

    const handleDeleteContaReceber = (contaReceberId: number) => {
        setConfirmDeleteContaReceberId(contaReceberId);
    };

    const executeDeleteContaReceber = () => {
        if (confirmDeleteContaReceberId == null) return;
        deleteContaReceber(confirmDeleteContaReceberId)
            .then(deletedContaReceber => {
                setGroupPage(1);
                if (!deletedContaReceber) console.error("Erro ao excluir conta.");
                getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId);
            })
            .catch(error => console.error("Erro ao excluir conta:", error));
        setConfirmDeleteContaReceberId(null);
    };

    const PARCELAS_VISIVEIS_INICIAL = 5;
    const [visibleCounts, setVisibleCounts] = useState<Record<number, number>>({});

    const toggleExpandVenda = (vendaId: number) => {
        setExpandedVendas(prev => {
            const next = new Set(prev);
            if (next.has(vendaId)) {
                next.delete(vendaId);
            } else {
                next.add(vendaId);
                // toda vez que expande de novo, começa mostrando só as 5 primeiras —
                // evita lembrar um "mostrar todas" anterior e voltar a poluir a tela.
                setVisibleCounts(vc => ({ ...vc, [vendaId]: PARCELAS_VISIVEIS_INICIAL }));
            }
            return next;
        });
    };

    const showMoreParcelas = (vendaId: number, total: number) => {
        setVisibleCounts(prev => ({
            ...prev,
            [vendaId]: Math.min((prev[vendaId] ?? PARCELAS_VISIVEIS_INICIAL) + PARCELAS_VISIVEIS_INICIAL, total),
        }));
    };

    // Agrupa itens CONSECUTIVOS com o mesmo vendaId (mesma noção de "grupo" que já
    // era usada pra desenhar a borda separadora) — parceladas de uma venda (ex.: 20x
    // boleto) viram 1 grupo, pra poder colapsar em 1 linha resumo na tabela.
    const gruposContaReceber = useMemo(() => {
        let lista = listContaReceber;
        if (filters.restricao === '1') {
            lista = lista.filter(x => !!x.permissaoVendaRestricao);
        } else if (filters.restricao === '0') {
            lista = lista.filter(x => !x.permissaoVendaRestricao);
        }

        const grupos: ContaReceberType[][] = [];
        for (const item of lista) {
            const grupoAtual = grupos[grupos.length - 1];
            if (grupoAtual && item.vendaId != null && grupoAtual[0].vendaId === item.vendaId) {
                grupoAtual.push(item);
            } else {
                grupos.push([item]);
            }
        }
        return grupos;
    }, [listContaReceber, filters.restricao]);

    // Paginação client-side sobre os GRUPOS (não sobre listContaReceber cru) — cada
    // "página" mostrada ao usuário sempre tem sentido, mesmo que uma venda parcelada
    // esconda dezenas de linhas cruas dentro de 1 grupo só.
    const groupPageCount = Math.max(1, Math.ceil(gruposContaReceber.length / pageSize));
    const gruposDaPagina = useMemo(
        () => gruposContaReceber.slice((groupPage - 1) * pageSize, groupPage * pageSize),
        [gruposContaReceber, groupPage, pageSize]
    );

    const toggleSelecionada = (id: number, status: number) => {
        if (status === 1) return; // não seleciona conta já concluída
        setSelecionadas(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    const handleBaixaLote = () => {
        if (selecionadas.size === 0) return;
        if (!window.confirm(`Dar baixa em ${selecionadas.size} conta(s) selecionada(s)?`)) return;

        efetuarBaixaLoteContaReceber(Array.from(selecionadas), new Date().toISOString())
            .then(success => {
                if (success) {
                    setSelecionadas(new Set());
                    setGroupPage(1);
                    getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId);
                }
            })
            .catch(error => console.error("Erro ao efetuar baixa em lote:", error));
    };

    const handleSyncRestricoes = async () => {
        if (syncingRestricoes) return;
        setSyncingRestricoes(true);
        try {
            const res = await sincronizarRestricoes();
            if (res?.sucesso) {
                handleSearch();
            }
        } finally {
            setSyncingRestricoes(false);
        }
    };

    // "Selecionar todas": marca todas as contas em aberto que o filtro atual carregou,
    // não só as visíveis na página.
    const idsSelecionaveis = useMemo(
        () => listContaReceber.filter(c => c.status !== 1).map(c => c.id),
        [listContaReceber]
    );
    const todasSelecionadas = idsSelecionaveis.length > 0 && idsSelecionaveis.every(id => selecionadas.has(id));

    const toggleSelecionarTodas = () => {
        setSelecionadas(todasSelecionadas ? new Set() : new Set(idsSelecionaveis));
    };

    const nomeArquivoBoleto = (conta: ContaReceberType) =>
        conta.totalParcelas > 1
            ? `boleto_parcela_${conta.numeroParcela}de${conta.totalParcelas}.pdf`
            : `boleto_${conta.id}.pdf`;

    const handleBaixarBoletoLinha = (conta: ContaReceberType) => {
        baixarBoletos([conta.id], "pdf", nomeArquivoBoleto(conta))
            .catch(error => console.error("Erro ao baixar boleto:", error));
    };

    // Abre o modal com as parcelas de boleto do grupo (venda) — a entrada (se houver) não
    // tem VendaBoletoId e fica de fora.
    const abrirBoletosDaVenda = (vendaId: number, grupo: ContaReceberType[]) => {
        setBoletoModalGrupo({
            vendaId,
            parcelas: grupo.filter(c => c.vendaBoletoId != null),
        });
    };

    // Verde só quando a conta está concluída (status 1) — na prática, só boleto fica
    // pendente (status 0); PIX e cartão já nascem concluídos. Demais linhas ficam brancas.
    const getRowColor = (status: number): string => {
        return status === 1 ? "#C8E6C9" : "#FFFFFF";
    };

    const renderContaReceberRow = (
        contaReceber: ContaReceberType,
        options?: {
            borderTop?: boolean;
            parcelaCell?: React.ReactNode;
            // Presente quando a linha pertence a uma venda parcelada — adiciona ao menu de
            // ações o atalho para o modal com todas as parcelas de boleto daquela venda.
            grupoBoletoAction?: { vendaId: number; parcelas: ContaReceberType[] };
        }
    ) => {
        // Parcela enviada ao SPC (marcada pelo atendente no Portal de Cobrança) sobrepõe a cor
        // por dia de vencimento — é o sinal mais importante da linha.
        const rowColor = contaReceber.enviadoSpc ? '#2b2b2b' : getRowColor(contaReceber.status);

        return (
            <tr
                key={contaReceber.id}
                className={contaReceber.enviadoSpc ? 'conta-spc' : undefined}
                title={contaReceber.enviadoSpc ? 'Dívida enviada ao SPC' : undefined}
                style={{
                    backgroundColor: rowColor,
                    borderTop: options?.borderTop ? '2px solid #8898aa' : undefined,
                }}
            >
                <td>
                    {contaReceber.status !== 1 && (
                        <input
                            type="checkbox"
                            checked={selecionadas.has(contaReceber.id)}
                            onChange={() => toggleSelecionada(contaReceber.id, contaReceber.status)}
                        />
                    )}
                </td>
                <td>{contaReceber.id}</td>
                <td>{contaReceber.codigoTransacao}</td>
                <td>{contaReceber.documento}</td>
                <td>
                    {/* max-width/wrap precisam estar num bloco DENTRO da célula, não na própria
                        <td> — em tabela com table-layout automático (o padrão), max-width numa
                        <td> não é respeitado de forma confiável e o texto acaba vazando por
                        cima das colunas vizinhas em vez de quebrar linha. */}
                    <div className="conta-observacao-compact" title={[
                        contaReceber.alunoNome ? `Aluno ${contaReceber.alunoNome}` : null,
                        contaReceber.historico,
                    ].filter(Boolean).join(' — ') || undefined}>
                        {contaReceber.alunoNome && <strong>Aluno {contaReceber.alunoNome}</strong>}
                        {contaReceber.alunoNome && contaReceber.historico && ' — '}
                        {contaReceber.historico}
                    </div>
                </td>
                <td>
                    {options?.parcelaCell !== undefined ? options.parcelaCell : (
                        contaReceber.totalParcelas > 1 ? (
                            <span className="badge badge-info">
                                {contaReceber.numeroParcela}/{contaReceber.totalParcelas}
                            </span>
                        ) : '-'
                    )}
                </td>
                <td>{new Date(contaReceber.dataEmissao).toLocaleDateString('pt-BR')}</td>
                <td>{contaReceber.vencimento && contaReceber.vencimento.split('-').reverse().join('/')}</td>
                <td>{contaReceber.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                <td>{contaReceber.taxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                <td>
                    {contaReceber.status === 0 && <span className="badge badge-warning">Pendente</span>}
                    {contaReceber.status === 1 && <span className="badge badge-success">Concluído</span>}
                    {contaReceber.permissaoVendaRestricao && (
                        <span
                            className="badge badge-danger ml-1"
                            title="Permissão de venda com restrição — cliente bloqueado / pendência na cobrança"
                        >
                            <i className="fa-solid fa-triangle-exclamation"></i> Restrição
                        </span>
                    )}
                </td>
                <td>{contaReceber.contaFinanceiraName}</td>
                <td>{contaReceber.categoriaFinanceiraName}</td>
                <td>{contaReceber.formaPagamentoName}</td>
                <td>
                    <ActionsMenu items={buildAcoesContaReceber(contaReceber, options?.grupoBoletoAction)} />
                </td>
            </tr>
        );
    };

    // Itens do menu de 3 pontinhos de cada linha — consolida o que antes era um conjunto de
    // ícones (info/editar/excluir/boleto/baixa) num único seletor, com posição calculada pra
    // nunca sair da tela (ver ActionsMenu).
    const buildAcoesContaReceber = (
        contaReceber: ContaReceberType,
        grupoBoletoAction?: { vendaId: number; parcelas: ContaReceberType[] }
    ): ActionsMenuItem[] => {
        const items: ActionsMenuItem[] = [
            {
                label: 'Ver informações completas',
                icon: 'fa-solid fa-circle-info',
                onClick: () => setDetalhesContaId(contaReceber.id),
            },
        ];

        if (hasPermission(PermissionModule.Financeiro, 3)) {
            items.push({
                label: 'Editar',
                icon: 'fa-solid fa-pen-to-square',
                onClick: () => handleEditContaReceber(contaReceber),
            });
        }

        if (contaReceber.vendaBoletoId != null) {
            items.push({
                label: 'Baixar boleto desta parcela',
                icon: 'fa-solid fa-barcode',
                onClick: () => handleBaixarBoletoLinha(contaReceber),
            });
        }

        if (grupoBoletoAction) {
            items.push({
                label: `Ver boletos desta venda (${grupoBoletoAction.parcelas.length})`,
                icon: 'fa-solid fa-list-check',
                onClick: () => abrirBoletosDaVenda(grupoBoletoAction.vendaId, grupoBoletoAction.parcelas),
            });
        }

        if (contaReceber.status !== 1) {
            items.push({
                label: 'Dar baixa nesta conta',
                icon: 'fa-solid fa-check',
                onClick: () => {
                    const request: EfetuarBaixaReceberRequest = {
                        contaReceberId: contaReceber.id,
                        dataBaixa: new Date().toISOString(),
                        valorPago: contaReceber.valor,
                    };
                    efetuarBaixaContaReceber(request)
                        .then(success => {
                            if (success) {
                                // Não reseta groupPage aqui: baixa individual não deve tirar o
                                // usuário da página em que está (ele pode estar clicando em
                                // várias linhas em sequência).
                                getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId);
                            } else {
                                console.error("Erro ao efetuar baixa na conta.");
                            }
                        })
                        .catch(error => console.error("Erro ao efetuar baixa:", error));
                },
            });

            if (selecionadas.size > 0 && hasPermission(PermissionModule.Financeiro, 3)) {
                items.push({
                    label: `Dar baixa nas ${selecionadas.size} selecionadas`,
                    icon: 'fa-solid fa-check-double',
                    onClick: handleBaixaLote,
                });
            }
        }

        if (hasPermission(PermissionModule.Financeiro, 4)) {
            items.push({
                label: 'Excluir',
                icon: 'fa-solid fa-trash',
                danger: true,
                dividerBefore: true,
                onClick: () => handleDeleteContaReceber(contaReceber.id),
            });
        }

        return items;
    };

    const listCategoriaFinanceiraOptions = listCategoriaFinanceiraByEmpresa.map(categoriaFinanceira => ({
        value: categoriaFinanceira.id,
        label: categoriaFinanceira.name,
    }));

    const listContaFinanceiraOptions = listContaFinanceiraByEmpresa.map(contaFinanceira => ({
        value: contaFinanceira.id,
        label: contaFinanceira.name,
    }));

    const listFormaPagamentoOptions = listFormaPagamentoByEmpresa.map(forma => ({
        value: forma.id,
        label: forma.name
    }));

    // Busca por nome ou pelo código de referência do aluno — se o texto digitado for
    // só números, assume que é o código; senão busca por nome.
    const loadAlunoOptions = async (inputValue: string) => {
        const texto = inputValue.trim();
        if (texto.length < 2) return [];

        const isCodigo = /^\d+$/.test(texto);
        const alunos = await getAlunoPaged(
            1, 0, 10,
            isCodigo ? undefined : texto,
            undefined,
            undefined,
            isCodigo ? Number(texto) : undefined,
            objUserTk.EmpresaId
        );
        return (alunos || []).map(aluno => ({
            value: aluno.id,
            label: aluno.referenceCode ? `${aluno.name} (#${aluno.referenceCode})` : aluno.name,
        }));
    };

    const blocoFiltros = (
        <>
                <Row className="align-items-center mb-2">
                    <Col xs="12" md="4" className="mb-2">
                        <Label className="form-control-label">Aluno</Label>
                        <AsyncSelect
                            className="form-control-alternative"
                            cacheOptions
                            defaultOptions={false}
                            loadOptions={loadAlunoOptions}
                            value={selectedAlunoOption}
                            onChange={(selected: any) => {
                                setSelectedAlunoOption(selected);
                                setFilters(prev => ({ ...prev, alunoId: selected?.value.toString() || '' }));
                            }}
                            isClearable
                            placeholder="Nome ou código do aluno..."
                            noOptionsMessage={(input) => input.inputValue.trim().length < 2 ? "Digite ao menos 2 caracteres" : "Nenhum aluno encontrado"}
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Data Inicial</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataInicial"
                            value={filters.dataInicial}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Data Final</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataFinal"
                            value={filters.dataFinal}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Status</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="status"
                            value={filters.status}
                            onChange={handleFilterChange}
                        >
                            <option value="">Todos</option>
                            <option value="0">Pendente</option>
                            <option value="1">Concluído</option>
                        </Input>
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Código Transação</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="codigoTransacao"
                            value={filters.codigoTransacao}
                            onChange={handleFilterChange}
                            placeholder="Código da transação"
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Documento</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="documento"
                            value={filters.documento}
                            onChange={handleFilterChange}
                            placeholder="Número do documento"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Observação</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="historico"
                            value={filters.historico}
                            onChange={handleFilterChange}
                            placeholder="Buscar pela observação"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Conta Financeira</Label>
                        <Select
                            className="form-control-alternative"
                            options={listContaFinanceiraOptions}
                            value={listContaFinanceiraOptions.find(opt => opt.value.toString() === filters.contaFinanceiraId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, contaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma conta financeira"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Categoria Financeira</Label>
                        <Select
                            className="form-control-alternative"
                            options={listCategoriaFinanceiraOptions}
                            value={listCategoriaFinanceiraOptions.find(opt => opt.value.toString() === filters.categoriaFinanceiraId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, categoriaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma categoria"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Forma de Pagamento</Label>
                        <Select
                            className="form-control-alternative"
                            options={listFormaPagamentoOptions}
                            value={listFormaPagamentoOptions.find(opt => opt.value.toString() === filters.formaPagamentoId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, formaPagamentoId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione a forma de pagamento"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Restrição</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="restricao"
                            value={filters.restricao}
                            onChange={handleFilterChange}
                        >
                            <option value="">Todas as contas</option>
                            <option value="1">⚠️ Somente com restrição</option>
                            <option value="0">Sem restrição</option>
                        </Input>
                    </Col>
                </Row>

                <Row className="align-items-center mb-4">
                    <Col xs="12" className="d-flex justify-content-start justify-content-md-end flex-wrap">
                        <Button
                            color="warning"
                            onClick={handleSyncRestricoes}
                            disabled={syncingRestricoes}
                            className="mr-2 mb-2 mb-md-0"
                            title="Sincroniza a flag de restrição dos alunos para todas as parcelas antigas no banco de dados"
                        >
                            <i className={`fa-solid ${syncingRestricoes ? 'fa-spinner fa-spin' : 'fa-arrows-rotate'} mr-1`}></i>
                            {syncingRestricoes ? 'Sincronizando...' : 'Sincronizar Restrições'}
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            onClick={handleSearch}
                            className="mr-2 mb-2 mb-md-0"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            onClick={handleClearFilters}
                            className="mb-2 mb-md-0"
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.Financeiro, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar conta
                            </Button>
                        </Col>
                    )}
                </Row>
        </>
    );

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Conta Receber"}
                search={false}
                titleSearch={""}
            />

            <Container fluid className="mt-5">
                {blocoFiltros}

                {hasPermission(PermissionModule.Financeiro, 2) ? (
                    <div className="tabela-contareceber-compact">
                    <Row className="mt-4">
                        <Col>
                            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                                <div>
                                    {hasPermission(PermissionModule.Financeiro, 3) && (
                                        <Button
                                            size="sm"
                                            disabled={selecionadas.size === 0}
                                            style={{
                                                color: "#FFF",
                                                backgroundColor: selecionadas.size === 0 ? "#adb5bd" : "#2dce89",
                                            }}
                                            className="mr-2"
                                            onClick={handleBaixaLote}
                                            title={selecionadas.size === 0
                                                ? "Selecione ao menos uma conta na tabela para dar baixa"
                                                : `Dar baixa em ${selecionadas.size} conta(s) selecionada(s)`}
                                        >
                                            <i className="fa-solid fa-check mr-2"></i>
                                            Dar baixa{selecionadas.size > 0 ? ` (${selecionadas.size})` : ''}
                                        </Button>
                                    )}
                                    {selecionadas.size > 0 && (
                                        <Button size="sm" color="link" onClick={() => setSelecionadas(new Set())}>
                                            Limpar seleção
                                        </Button>
                                    )}
                                </div>
                            </div>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>
                                            {idsSelecionaveis.length > 0 && (
                                                <input
                                                    type="checkbox"
                                                    title="Selecionar todas as contas em aberto do filtro atual"
                                                    checked={todasSelecionadas}
                                                    onChange={toggleSelecionarTodas}
                                                />
                                            )}
                                        </th>
                                        {/* Cabeçalhos abreviados (nome completo no title) — junto com a
                                            Observação quebrando linha em vez de cortar, é a tentativa de
                                            caber tudo na tela sem esconder informação. */}
                                        <th title="Sequência">Seq.</th>
                                        <th title="Código Transação">Cód. Transação</th>
                                        <th title="Documento">Doc.</th>
                                        <th title="Observação">Obs.</th>
                                        <th>Parcela</th>
                                        <th title="Data de Emissão">Emissão</th>
                                        <th title="Vencimento">Vencto.</th>
                                        <th>Valor</th>
                                        <th>Taxa</th>
                                        <th>Status</th>
                                        <th title="Conta Financeira">Conta</th>
                                        <th title="Categoria Financeira">Categ.</th>
                                        <th title="Forma de Pagamento">Forma Pgmt.</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gruposDaPagina.map((grupo) => {
                                        const vendaId = grupo[0].vendaId;
                                        const isParcelado = grupo.length > 1 && vendaId != null;
                                        const expanded = isParcelado && expandedVendas.has(vendaId as number);

                                        // Só existe "boletos da venda" pra vendas parceladas — conta
                                        // avulsa já resolve com "Baixar boleto desta parcela" no menu.
                                        const boletosDaVenda = isParcelado
                                            ? grupo.filter(c => c.vendaBoletoId != null)
                                            : [];
                                        const grupoBoletoAction = boletosDaVenda.length > 0
                                            ? { vendaId: vendaId as number, parcelas: boletosDaVenda }
                                            : undefined;

                                        if (isParcelado && !expanded) {
                                            // Resumo: mostra a próxima parcela em aberto (ou a última, se
                                            // todas já concluídas) e esconde o resto até o usuário expandir.
                                            const destaque = grupo.find(c => c.status !== 1) ?? grupo[grupo.length - 1];

                                            // Quantas parcelas deveriam existir x quantas estão lançadas. Uma
                                            // diferença aqui significa parcela faltando na Contas a Receber
                                            // (ex.: linha excluída) — sem esse aviso o resumo parece normal e
                                            // o buraco só aparece se alguém expandir e conferir a numeração.
                                            const parcelasDoGrupo = grupo.filter(c => c.totalParcelas > 1);
                                            const totalEsperado = parcelasDoGrupo[0]?.totalParcelas ?? 0;
                                            const faltando = totalEsperado > 0 ? totalEsperado - parcelasDoGrupo.length : 0;

                                            return renderContaReceberRow(destaque, {
                                                borderTop: true,
                                                grupoBoletoAction,
                                                parcelaCell: (
                                                    <span style={{ whiteSpace: 'nowrap' }}>
                                                        <span
                                                            className="badge badge-info"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => toggleExpandVenda(vendaId as number)}
                                                            title={`Próxima parcela em aberto. Clique para ver todas as ${parcelasDoGrupo.length} parcelas lançadas.`}
                                                        >
                                                            Próx. {destaque.numeroParcela}/{destaque.totalParcelas}{' '}
                                                            <i className="fa-solid fa-angles-down"></i>
                                                        </span>
                                                        {faltando > 0 && (
                                                            <span
                                                                className="badge badge-danger ml-1"
                                                                title={`Esta venda tem ${totalEsperado} parcelas, mas só ${parcelasDoGrupo.length} estão lançadas em Contas a Receber. ${faltando} parcela(s) não aparecem aqui.`}
                                                            >
                                                                <i className="fa-solid fa-triangle-exclamation"></i> falta {faltando}
                                                            </span>
                                                        )}
                                                    </span>
                                                ),
                                            });
                                        }

                                        if (isParcelado) {
                                            const visibleCount = visibleCounts[vendaId as number] ?? PARCELAS_VISIVEIS_INICIAL;
                                            const visiveis = grupo.slice(0, visibleCount);
                                            const restantes = grupo.length - visiveis.length;

                                            const linhas = visiveis.map((contaReceber, i) => renderContaReceberRow(contaReceber, {
                                                borderTop: i === 0,
                                                grupoBoletoAction,
                                                parcelaCell: (
                                                    <span
                                                        className="badge badge-info"
                                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                                        onClick={() => toggleExpandVenda(vendaId as number)}
                                                        title="Recolher parcelas"
                                                    >
                                                        {contaReceber.numeroParcela}/{contaReceber.totalParcelas}
                                                        {i === 0 && <> <i className="fa-solid fa-angles-up"></i></>}
                                                    </span>
                                                ),
                                            }));

                                            if (restantes > 0) {
                                                linhas.push(
                                                    <tr key={`mostrar-mais-${vendaId}`}>
                                                        <td colSpan={15} className="text-center">
                                                            <Button
                                                                size="sm"
                                                                color="link"
                                                                onClick={() => showMoreParcelas(vendaId as number, grupo.length)}
                                                            >
                                                                Mostrar mais {Math.min(PARCELAS_VISIVEIS_INICIAL, restantes)} (faltam {restantes} de {grupo.length})
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                );
                                            }

                                            return linhas;
                                        }

                                        return grupo.map((contaReceber, i) => renderContaReceberRow(contaReceber, {
                                            borderTop: i === 0 && vendaId != null,
                                        }));
                                    })}
                                </tbody>
                            </Table>
                            <div className="text-right mt-3">
                                <strong>
                                    Total das contas filtradas:&nbsp;
                                    {typeof contaReceberTotalValor === "number"
                                        ? contaReceberTotalValor.toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        })
                                        : "R$ 0,00"}
                                </strong>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            // Só reparticiona os grupos já carregados — não busca nada
                                            // novo do backend (ver RAW_FETCH_SIZE acima).
                                            setPageSize(parseInt(e.target.value));
                                            setGroupPage(1);
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {groupPageCount > 1 && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={groupPageCount}
                                            page={groupPage}
                                        />
                                    </div>
                                )}

                                {listContaReceber.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                    </div>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as contas do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <DetalhesContaReceberModal
                isOpen={detalhesContaId != null}
                toggle={() => setDetalhesContaId(null)}
                contaReceberId={detalhesContaId}
            />

            <BoletoParcelasModal
                isOpen={boletoModalGrupo != null}
                toggle={() => setBoletoModalGrupo(null)}
                vendaId={boletoModalGrupo?.vendaId ?? null}
                parcelas={boletoModalGrupo?.parcelas ?? []}
            />

            <CreateContaReceberModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => { setGroupPage(1); getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId); }}
            />

            <EditContaReceberModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                conta={editingContaReceber}
                onUpdated={() => { setGroupPage(1); getAllContaReceberPaged(1, RAW_FETCH_SIZE, objUserTk.EmpresaId); }}
            />

            <ModalConfirm
                openModal={confirmDeleteContaReceberId !== null}
                closeModal={() => setConfirmDeleteContaReceberId(null)}
                handleConfirm={executeDeleteContaReceber}
                title="Excluir conta"
                message="Tem certeza que deseja excluir esta conta? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default ContaReceber;